export default from './Slider'